import React from "react";
import injectSheet from "react-jss";

const style = ({ theme }) => ({
  gradient: {
    marginTop: "41px",
    height: 8,
    background: "linear-gradient(90deg, #FA7F25 0%, #FDBE13 100%)"
  }
});

const Footer = ({ classes }) => {
  return <div className={classes.gradient} />;
};

export default injectSheet(style)(Footer);
